export enum EPsychoeducationActions {
  GET_PSYCHOEDUCATION_TOPICS = 'GET_PSYCHOEDUCATION_TOPICS',
  GET_PSYCHOEDUCATION_BY_TOPIC = 'GET_PSYCHOEDUCATION_BY_TOPIC',
  LOAD_MORE_PSYCHOEDUCATION_BY_TOPIC = 'LOAD_MORE_PSYCHOEDUCATION_BY_TOPIC',
  GET_DETAILS_PSYCHOEDUCATION = 'GET_DETAILS_PSYCHOEDUCATION',
}
